import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mt-2" };
const _hoisted_2 = { class: "d-flex align-center ga-2 mb-1" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 1,
    class: "mt-1"
};
const _hoisted_5 = {
    key: 2,
    class: "mt-2"
};
const _hoisted_6 = {
    key: 0,
    class: "text-medium-emphasis"
};
const _hoisted_7 = {
    key: 1,
    class: "text-medium-emphasis"
};
const _hoisted_8 = { key: 3 };
import { ref } from "vue";
import { miscService } from "@/services/miscService";
import { ApiError } from "@/services/api";
const bookmarkletHref = "javascript:void((async()=>{try{const m=window.location.href.match(/requests\\/([a-zA-Z0-9]+)/);if(!m){alert('Not on a CMM request page');return;}const r=await fetch('/api/requests/'+m[1],{credentials:'same-origin',headers:{Accept:'application/json'}});if(!r.ok){alert('API error: '+r.status);return;}const j=await r.json();await navigator.clipboard.writeText(JSON.stringify(j));const d=document.createElement('div');d.textContent='CMM JSON copied! ('+m[1]+')';d.style.cssText='position:fixed;top:20px;right:20px;background:%234CAF50;color:white;padding:16px 24px;border-radius:8px;z-index:99999;font-size:16px;box-shadow:0 4px 12px rgba(0,0,0,0.3)';document.body.appendChild(d);setTimeout(()=>d.remove(),3000)}catch(e){alert('Error: '+e.message)}})())";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OpsUtilities',
    setup(__props) {
        const errorMessage = ref("");
        const loading = ref(false);
        const s3LinksForRefresh = ref("");
        const refreshedS3Links = ref([]);
        const refreshS3Link = async () => {
            errorMessage.value = "";
            try {
                loading.value = true;
                const s3Links = s3LinksForRefresh.value
                    .replaceAll(/[\[\]'"]/g, "")
                    .trim()
                    .split(",")
                    .map((link) => link.trim());
                const response = await miscService.regenerateS3Links(s3Links);
                refreshedS3Links.value = response;
            }
            catch (error) {
                errorMessage.value = error instanceof ApiError ? error.message.toString() : `An unknown error occurred: ${error}`;
            }
            finally {
                loading.value = false;
            }
        };
        // CMM JSON Import — bookmarklet for copying CMM request JSON
        const cmmOrderKey = ref("");
        const cmmJsonText = ref("");
        const cmmLoading = ref(false);
        const cmmError = ref(null);
        // NOTE: Fields are camelCase — axios response interceptor (api.js:50) auto-camelizes snake_case backend responses.
        const cmmResult = ref(null);
        const processCMMJson = async () => {
            cmmError.value = null;
            cmmResult.value = null;
            if (!cmmOrderKey.value.trim()) {
                cmmError.value = "Order key is required.";
                return;
            }
            if (!cmmJsonText.value.trim()) {
                cmmError.value = "CMM JSON is required.";
                return;
            }
            let parsed;
            try {
                parsed = JSON.parse(cmmJsonText.value);
            }
            catch {
                cmmError.value = "Invalid JSON. Please check the pasted content.";
                return;
            }
            if (!parsed.sections || !Array.isArray(parsed.sections)) {
                cmmError.value = 'JSON must contain a "sections" array.';
                return;
            }
            try {
                cmmLoading.value = true;
                const response = await miscService.processCMMJson({
                    order_key: cmmOrderKey.value.trim(),
                    cmm_json: parsed,
                });
                cmmResult.value = response;
            }
            catch (error) {
                cmmError.value = error instanceof ApiError ? error.message.toString() : `An unknown error occurred: ${error}`;
            }
            finally {
                cmmLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _cache[21] || (_cache[21] = _createElementVNode("h1", null, "Ops Utilities", -1)),
                    _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                            (errorMessage.value)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 0,
                                    type: "error",
                                    variant: "tonal",
                                    closable: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(errorMessage.value), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createElementVNode("h2", null, "Refresh S3 Links", -1)
                                        ])),
                                        _: 1,
                                        __: [3]
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                modelValue: s3LinksForRefresh.value,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((s3LinksForRefresh).value = $event)),
                                                label: "S3 Links"
                                            }, null, 8, ["modelValue"]),
                                            _cache[4] || (_cache[4] = _createTextVNode(" Please paste a comma separated list of S3 links, with or without quotes or \"[]\" (can also be just one link). ", -1))
                                        ]),
                                        _: 1,
                                        __: [4]
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                                loading: loading.value,
                                                onClick: refreshS3Link
                                            }, {
                                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                    _createTextVNode("Refresh S3 Link", -1)
                                                ])),
                                                _: 1,
                                                __: [5]
                                            }, 8, ["loading"])
                                        ]),
                                        _: 1
                                    }),
                                    (refreshedS3Links.value.length > 0)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12"
                                        }, {
                                            default: _withCtx(() => [
                                                _cache[6] || (_cache[6] = _createElementVNode("b", null, "Refreshed S3 Links:", -1)),
                                                _createVNode(_component_v_list, null, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refreshedS3Links.value, (link) => {
                                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: link,
                                                                style: { 'line-break': 'anywhere' }
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(link), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1024));
                                                        }), 128))
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1,
                                            __: [6]
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_divider, { class: "my-6" }),
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                            _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Import CMM Request JSON", -1)),
                                            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-body-2 mt-1 mb-2" }, " To copy CMM JSON: open the request in CMM, then run this bookmarklet (drag to bookmark bar): ", -1)),
                                            _createVNode(_component_v_chip, {
                                                variant: "outlined",
                                                class: "mb-3",
                                                style: { "cursor": "grab", "user-select": "none" },
                                                href: bookmarkletHref,
                                                draggable: "true"
                                            }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                    _createTextVNode(" Copy CMM JSON ", -1)
                                                ])),
                                                _: 1,
                                                __: [7]
                                            })
                                        ]),
                                        _: 1,
                                        __: [8, 9]
                                    }),
                                    _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "6"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                modelValue: cmmOrderKey.value,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((cmmOrderKey).value = $event)),
                                                label: "Order Key",
                                                placeholder: "Enter the order key"
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_textarea, {
                                                modelValue: cmmJsonText.value,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((cmmJsonText).value = $event)),
                                                label: "CMM Request JSON",
                                                rows: "10",
                                                placeholder: "Paste the CMM request JSON here (must contain a \"sections\" array)"
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                                loading: cmmLoading.value,
                                                onClick: processCMMJson
                                            }, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                    _createTextVNode("Process JSON", -1)
                                                ])),
                                                _: 1,
                                                __: [10]
                                            }, 8, ["loading"])
                                        ]),
                                        _: 1
                                    }),
                                    (cmmError.value)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_alert, {
                                                    type: "error",
                                                    variant: "tonal",
                                                    density: "compact"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(cmmError.value), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (cmmResult.value)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            cols: "12"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_alert, {
                                                    type: "success",
                                                    variant: "tonal"
                                                }, {
                                                    title: _withCtx(() => _cache[11] || (_cache[11] = [
                                                        _createTextVNode("CMM JSON imported successfully", -1)
                                                    ])),
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_1, [
                                                            _createElementVNode("div", _hoisted_2, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("b", null, "Order:", -1)),
                                                                _createTextVNode(" " + _toDisplayString(cmmResult.value.orderKey) + " ", 1),
                                                                (cmmResult.value.orderKey)
                                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                        key: 0,
                                                                        variant: "text",
                                                                        size: "small",
                                                                        density: "compact",
                                                                        href: `/admin-iMNE4Dm9tkm1/portal/orderinfo/${cmmResult.value.orderKey}/change/`,
                                                                        target: "_blank"
                                                                    }, {
                                                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                            _createTextVNode(" Open in Admin ", -1)
                                                                        ])),
                                                                        _: 1,
                                                                        __: [12]
                                                                    }, 8, ["href"]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            (cmmResult.value.processingSummary?.formName)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                                    _cache[14] || (_cache[14] = _createElementVNode("b", null, "Form:", -1)),
                                                                    _createTextVNode(" " + _toDisplayString(cmmResult.value.processingSummary.formName), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("div", null, [
                                                                _cache[15] || (_cache[15] = _createElementVNode("b", null, "Status:", -1)),
                                                                (cmmResult.value.processingSummary?.previousStatus &&
                                                                    cmmResult.value.processingSummary.previousStatus !== cmmResult.value.status)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        _createTextVNode(_toDisplayString(cmmResult.value.processingSummary.previousStatus) + " → ", 1)
                                                                    ], 64))
                                                                    : _createCommentVNode("", true),
                                                                _createTextVNode(" " + _toDisplayString(cmmResult.value.status), 1)
                                                            ]),
                                                            _createElementVNode("div", null, [
                                                                _cache[16] || (_cache[16] = _createElementVNode("b", null, "Pipeline Step:", -1)),
                                                                (cmmResult.value.processingSummary?.previousPipelineStep &&
                                                                    cmmResult.value.processingSummary.previousPipelineStep !== cmmResult.value.pipelineStep)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        _createTextVNode(_toDisplayString(cmmResult.value.processingSummary.previousPipelineStep) + " → ", 1)
                                                                    ], 64))
                                                                    : _createCommentVNode("", true),
                                                                _createTextVNode(" " + _toDisplayString(cmmResult.value.pipelineStep), 1)
                                                            ]),
                                                            (cmmResult.value.processingSummary?.cmmState)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                                    _cache[17] || (_cache[17] = _createElementVNode("b", null, "CMM State:", -1)),
                                                                    _createVNode(_component_v_chip, {
                                                                        size: "small",
                                                                        class: "ml-1",
                                                                        color: cmmResult.value.processingSummary.cmmState.isApproved
                                                                            ? 'success'
                                                                            : cmmResult.value.processingSummary.cmmState.isDenied
                                                                                ? 'error'
                                                                                : cmmResult.value.processingSummary.cmmState.isUnknown
                                                                                    ? 'warning'
                                                                                    : undefined
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(cmmResult.value.processingSummary.cmmState.workflowStatus || "None"), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["color"])
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (cmmResult.value.processingSummary)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                                    _cache[18] || (_cache[18] = _createElementVNode("b", null, "Fields Updated:", -1)),
                                                                    _createTextVNode(" " + _toDisplayString(cmmResult.value.processingSummary.updatedFields?.length || 0) + " ", 1),
                                                                    (cmmResult.value.processingSummary.updatedFields?.length)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(cmmResult.value.processingSummary.updatedFields.join(", ")) + ") ", 1))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, "(no changes)"))
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (cmmResult.value.processingSummary)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                                    _cache[19] || (_cache[19] = _createElementVNode("b", null, "Basic+ Questions:", -1)),
                                                                    _createTextVNode(" " + _toDisplayString(cmmResult.value.processingSummary.basicPlusQuestionsCount || 0) + " · ", 1),
                                                                    _cache[20] || (_cache[20] = _createElementVNode("b", null, "Payer Questions:", -1)),
                                                                    _createTextVNode(" " + _toDisplayString(cmmResult.value.processingSummary.payerQuestionsExtracted ? "Yes" : "No"), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1,
                __: [21]
            }));
        };
    }
});
